import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUnreadMessagesAction } from 'store/message/messageActions';
import { downloadMessageFile } from 'utils/apiCalls';
import { downloadFile } from 'utils/utilMethods';
import ChatInput from './ChatInput';

Chat.propTypes = {
  messages: PropTypes.array,
};

const useStyles = makeStyles(() => ({
  scrollContainer: {
    maxHeight: '85vh',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
}));

export default function Chat() {
  const theme = useTheme();
  const classes = useStyles();
  const { name, externalMeetingId, meetingId, messages } = useSelector(({ chime, message }) => ({
    name: chime.name,
    externalMeetingId: chime.externalMeetingId,
    meetingId: chime.meetingId,
    messages: message.messages,
  }));
  const messagesBox = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setUnreadMessagesAction(0));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (messagesBox?.current) {
        messagesBox.current.scrollTop = messagesBox.current?.scrollHeight;
      }
    }, 10);
  }, [messages]);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
      data-testid="chat-box"
    >
      <Box flexGrow={1} />
      <Box className={classes.scrollContainer} ref={messagesBox}>
        {messages.map((message) => {
          const messageString = message.payload.message;
          const messageId = `${message.meetingId}-${message.Date}-${message.payload?.attendeeId}`; // Just need a unique id, messages don't come with one.
          const isMe = name.toLowerCase() === message?.payload?.name?.toLowerCase();
          return (
            <Box
              data-testid="message-box"
              key={messageId}
              flexDirection="row"
              display="flex"
              justifyContent={isMe ? 'flex-end' : 'flex-start'}
              margin={2}
            >
              <Grid
                container
                wrap="wrap"
                direction="row"
                style={{
                  textAlign: 'left',
                  width: '70%',
                  color: isMe ? 'white' : 'black',
                  backgroundColor: isMe ? theme.palette.primary.main : '#d7d7de',
                  borderRadius: 4,
                }}
              >
                <Grid item xs={12}>
                  <div style={{ marginTop: 5, marginLeft: 7, marginRight: 7 }}>
                    {`${message.payload.name} ${moment(message.Date).format('h:mm A')}`}
                  </div>
                </Grid>
                {message?.payload?.fileName && (
                  <Grid item xs={12}>
                    <Box
                      style={{
                        cursor: 'pointer',
                        backgroundColor: theme.palette.secondary.primary,
                        display: 'flex',
                        flexDirection: 'row',
                        flexGrow: 1,
                        marginLeft: 7,
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                      onClick={async () => {
                        const { url } = await downloadMessageFile(
                          externalMeetingId,
                          meetingId,
                          message?.payload?.fileId
                        );
                        await downloadFile(message?.payload?.fileName, url);
                      }}
                    >
                      <div>
                        <CloudDownloadIcon />
                      </div>

                      <div style={{ marginLeft: 2 }}>{message?.payload?.fileName}</div>
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <div style={{ marginBottom: 5, marginLeft: 7, marginRight: 7 }}>
                    <Typography>{messageString}</Typography>
                  </div>
                </Grid>
              </Grid>
            </Box>
          );
        })}
      </Box>
      <Box marginBottom={2} minHeight="10vh">
        <ChatInput />
      </Box>
    </Box>
  );
}
